import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Tabs, Tag, SpinLoading, ErrorBlock, AutoCenter } from 'antd-mobile';
import { WebviewHttpHandler } from 'shared/webviewHttpHandler';
import secureStorage from 'shared/secureStorage';
const webviewHttpHandler = new WebviewHttpHandler(true);

const days = ['週日', '週一', '週二', '週三', '週四', '週五', '週六'];

// 根据预约状态返回对应的标签
const getTagByStatus = (status) => {
  switch (status) {
    case '1':
    case 1:
      return (
        <Tag
          color="#E60012"
          style={{
            '--border-radius': '4px',
            fontSize: '18px',
            padding: '4px 8px',
            marginBottom: '4px',
          }}>
          即將赴約
        </Tag>
      );
    case '2':
    case 2:
      return (
        <Tag
          color="#212224"
          style={{
            '--border-radius': '4px',
            fontSize: '18px',
            padding: '4px 8px',
            marginBottom: '4px',
          }}>
          已赴約
        </Tag>
      );
    case '3':
    case 3:
      return (
        <Tag
          color="#E60012"
          fill="outline"
          style={{
            '--border-radius': '4px',
            fontSize: '18px',
            padding: '4px 8px',
            marginBottom: '4px',
            backgroundColor: '#FFEAED',
            borderColor: '#FFEAED',
          }}>
          未赴約
        </Tag>
      );
    case '4':
    case 4:
      return (
        <Tag
          color="#ADB1B8"
          style={{
            '--border-radius': '4px',
            fontSize: '18px',
            padding: '4px 8px',
            marginBottom: '4px',
          }}>
          已取消
        </Tag>
      );
    default:
      return (
        <Tag
          color="#ADB1B8"
          style={{
            '--border-radius': '4px',
            fontSize: '18px',
            padding: '4px 8px',
            marginBottom: '4px',
          }}>
          未確認
        </Tag>
      );
  }
};

const AppointmentList = ({
  appText1,
  appText2,
  appText3,
  appFinalText,
  status,
  address,
  memo,
  isLastItem,
}) => (
  <div>
    <div className="my-6">
      {getTagByStatus(status)}
      <div className="text-body font-normal">
        {appFinalText ? (
          <>
            <div className="mb-1">
              <div>確認時間: {appFinalText}</div>
            </div>
          </>
        ) : (
          <>
            <div className="mb-1">
              <div>預約時間1: {appText1}</div>
            </div>
            <div className="mb-1">
              <div>預約時間2: {appText2}</div>
            </div>
            <div className="mb-1">
              <div>預約時間3: {appText3}</div>
            </div>
          </>
        )}
        <div className="mb-1">
          <div>預約地址: {address}</div>
        </div>
        <div className="mb-1">
          <div>備註: {memo}</div>
        </div>
      </div>
    </div>
    {!isLastItem && <hr />}
  </div>
);

const Appointment = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const { plateNumber } = location.state;
  const lineUserId = secureStorage.getItem('lineUserId');
  const [appointmentData, setAppointmentData] = useState({
    // 驗車
    category1: [],
    // 保養
    category2: [],
  });

  const reformatData = (data) => {
    let id = 0;
    return data.map((item) => {
      let appText1 = '';
      if (item.app_1) {
        const appDate1 = new Date(item.app_1);
        const data1 = appDate1.toISOString().split('T')[0].replace(/-/g, '/');
        const time1 = appDate1.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
        appText1 = data1 + ' ' + time1;
      }

      let appText2 = '';
      if (item.app_2) {
        const appDate2 = new Date(item.app_2);
        const data2 = appDate2.toISOString().split('T')[0].replace(/-/g, '/');
        const time2 = appDate2.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
        appText2 = data2 + ' ' + time2;
      }

      let appText3 = '';
      if (item.app_3) {
        const appDate3 = new Date(item.app_3);
        const data3 = appDate3.toISOString().split('T')[0].replace(/-/g, '/');
        const time3 = appDate3.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
        appText3 = data3 + ' ' + time3;
      }

      let finalText = '';
      if (item.final_date) {
        const finalDate = new Date(item.final_date);
        const date4 = finalDate.toISOString().split('T')[0].replace(/-/g, '/');
        const time4 = finalDate.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
        finalText = date4 + ' ' + time4;
      }

      return {
        ...item,
        app_text_1: appText1,
        app_text_2: appText2,
        app_text_3: appText3,
        app_final_text: finalText,
        id: id++,
      };
    });
  };

  const getAppointmentDetails = () => {
    Promise.all([
      webviewHttpHandler.get(
        `/service/member/appointment?category=1&line=${lineUserId}&car=${plateNumber}`
      ),
      webviewHttpHandler.get(
        `/service/member/appointment?category=2&line=${lineUserId}&car=${plateNumber}`
      ),
    ]).then(([res1, res2]) => {
      setAppointmentData({
        category1: reformatData(res1.data),
        category2: reformatData(res2.data),
      });
      setLoading(false);
    });
  };
  useEffect(() => {
    getAppointmentDetails();
  }, []);
  return (
    <>
      <div className="bill-container">
        <div className="heading font-bold mb-6 ml-3">預約記錄</div>
        <Tabs>
          <Tabs.Tab title="保養紀錄" key="category2">
            {loading ? (
              <AutoCenter className="mt-8">
                <SpinLoading />
              </AutoCenter>
            ) : appointmentData.category2.length === 0 ? (
              <ErrorBlock
                status="empty"
                title={<>沒有保養預約紀錄</>}
                description={<></>}
              />
            ) : (
              <div>
                {appointmentData.category2.map((detail, index) => (
                  <AppointmentList
                    key={detail.id}
                    status={detail.status}
                    appText1={detail.app_text_1}
                    appText2={detail.app_text_2}
                    appText3={detail.app_text_3}
                    appFinalText={detail.app_final_text}
                    address={detail.address}
                    memo={detail.memo}
                    isLastItem={index === appointmentData.category2.length - 1}
                  />
                ))}
              </div>
            )}
          </Tabs.Tab>
          <Tabs.Tab title="驗車紀錄" key="category1">
            {loading ? (
              <AutoCenter className="mt-8">
                <SpinLoading />
              </AutoCenter>
            ) : appointmentData.category1.length === 0 ? (
              <ErrorBlock
                status="empty"
                title={<>沒有驗車預約紀錄</>}
                description={<></>}
              />
            ) : (
              <div>
                {appointmentData.category1.map((detail, index) => (
                  <AppointmentList
                    key={detail.id}
                    status={detail.status}
                    appText1={detail.app_text_1}
                    appText2={detail.app_text_2}
                    appText3={detail.app_text_3}
                    appFinalText={detail.app_final_text}
                    address={detail.address}
                    memo={detail.memo}
                    isLastItem={index === appointmentData.category1.length - 1}
                  />
                ))}
              </div>
            )}
          </Tabs.Tab>
        </Tabs>
      </div>
    </>
  );
};

export default Appointment;
